import { Button, ButtonProps } from '@atoms/index';
import { FormTitle } from '@molecules/index';
import { ConfirmationBanner } from '@organisms/index';
import { FeedbackLink } from '@molecules/*';
import React from 'react';

interface ConfirmationTemplateProps {
  reference?: string | undefined;
  contentTitle?: string;
  contentSubtext?: string | React.ReactNode;
  content?: React.ReactNode;
  feedbackLink?: boolean;
  button?: ButtonProps;
  confirmationTitle?: string;
}
export const ConfirmationTemplate: React.FC<ConfirmationTemplateProps> = ({
  reference,
  contentTitle,
  contentSubtext,
  content,
  feedbackLink,
  button,
  confirmationTitle = '',
}) => {
  return (
    <>
      <ConfirmationBanner reference={reference} title={confirmationTitle} />
      <section data-testid="content" className="my-4 flex flex-col">
        {content ? (
          <>{content}</>
        ) : (
          <FormTitle
            text={contentTitle ?? `What happens next?`}
            subtext={contentSubtext}
          />
        )}
      </section>
      <section className="mb-10">{feedbackLink && <FeedbackLink />}</section>
      {button ? (
        <section data-testid="navigate-to-homepage">
          <Button
            id="navigation-button"
            variant="primary"
            color="navigation-primary"
            label={button.label}
            onClick={button.onClick}
            {...button}
          />
        </section>
      ) : null}
    </>
  );
};
